import { useJewelleryContext } from "context/JwelleryPriceContext";
import { useEffect, useState } from "react";

interface JewelleryPriceProps {
  jewellery: any;
  type: "diamond" | "metal" | "total";
}

const JewelleryPrice: React.FC<JewelleryPriceProps> = ({ jewellery, type }) => {
  const [diamondTotal, setDiamondTotal] = useState<number | null>(null);

  const { getDiamondPrices, handleJewelleryPrice } = useJewelleryContext();
  // const mainDiamond = {
  //   id: "main-stone",
  //   carat: 1,
  //   color: "DEF",
  //   clarity: "VVS",
  //   shape: jewellery?.shape, // Using product shape
  //   pieces: 1,
  // };

  // const diamondsWithMain: any = [mainDiamond, ...jewellery?.diamonds];
  const price: any = handleJewelleryPrice(
    jewellery,
    "yellowgold",
    "18k",
    // response,
    1,
    "separate"
  );
  // const getJewelleryPrice = async () => {
  //   try {
  //     const response: any = await getDiamondPrices(diamondsWithMain);
  //     let valueToSet = 0;
  //     if (type === "diamond") valueToSet = price?.diamondPrices;
  //     else if (type === "metal") valueToSet = price?.metalTotal;
  //     else if (type === "total")
  //       valueToSet = price?.diamondPrices + price?.metalTotal;
  //     setDiamondTotal(valueToSet);
  //   } catch (err) {
  //     console.error("Failed to fetch diamond price", err);
  //   }
  // };
  // useEffect(() => {
  //   getJewelleryPrice();
  // }, [jewellery]);

  return <span>$ {price?.diamondPrices}</span>;
};

export default JewelleryPrice;
